/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { useSelector } from 'react-redux';
// material
import { Header, Group, Logo, Icon, Link, BubbleNav, LinkMenu, UnsavedMessage, Badge } from '@insticator/insticator-ui'; // iui-material
import RedirectToVersionTwo from 'material/ctas/redirecttoversiontwo/redirecttoversiontwo'


/* ========== ~~~~~~~~~~ STRUCTURE : HEADER ~~~~~~~~~~ ========== */
const LocalHeader = (props) => {
	// application state
    const permissions = useSelector(({ sessionStatus }) => sessionStatus.permissions);
    const mocked = useSelector(({ sessionStatus }) => sessionStatus.mocked);
    const userEmail = useSelector(({ sessionStatus }) => sessionStatus.userEmail);
    const showPubPortalV2Button = useSelector(({ accountData }) => accountData.showPubPortalV2Button);

	let signOutClicked = false;
	const handleSignOut = () => {
		if(signOutClicked) return null;
		if (props.editMode){
			return props.displayModal(true, <UnsavedMessage primaryAction={processSignOut} />);
		}
        return processSignOut();
	};
	const processSignOut = () => {
		signOutClicked = true;
        if(window.heap) window.heap.resetIdentity();
		props.mocked ? props.unmockUser() : props.mockupGenerator ? props.redirectToMockupGenerator(props.siteUUID, props.mockupGeneratorSource) : props.signOut()
	};
	const isInsticatorUser = () => mocked || /@insticator.com\s*$/.test(userEmail)

	return (
		<Header
			logo={{ type: 'internal', action: 'dashboard/home' }}
			content={
				<Group name={`navs`}>
					<Group name={`sections`}>
						 <BubbleNav
						 	name={'topnav'}
						 	items={[
								...!props.mockupGenerator ? [{ name: 'home', text: 'Home', icon: 'chart-line', type: 'internal', action: 'dashboard/home' }] : [],
						 		{ name: 'embeds', text: 'Embeds', icon: 'puzzle-piece', type: 'internal', action: 'dashboard/embeds' },
								...!props.mockupGenerator ? [{ name: 'reports', text: 'Reports', icon: 'chart-pie', type: 'internal', action: 'dashboard/reports', permitted: props.reportsPermitted }] : [],
								{ name: 'comments', text: `Commenting`, icon: 'comment-alt', type: 'internal', action: 'dashboard/commenting', permitted: true },
								// { name: 'ratings', text: `Ratings`, icon: 'star-half-alt', type: 'internal', action: 'dashboard/ratings', permitted: true } {/* Remove/Hide Ratings Menu and Page */}
						 	]}
						 />
					</Group>
					<Group name={`account`}>
						{(isInsticatorUser() || showPubPortalV2Button) && <RedirectToVersionTwo />}
						<div className={`greeting`}>{!props.mockupGenerator ? 'Welcome' : null}</div>
						{!props.mockupGenerator && <LinkMenu
							name={`usermenu`}
							indicator={<span className={`username`}>{`${!!props.userFirstName ? props.userFirstName : ''}`} <Icon name={`sort-down`} /></span>}
							groups={[
								{
									name: 'accountitems',
									title: 'Account',
									items: [
										{ name: 'profile', text: 'Profile Information', icon: 'id-card', type: 'internal', action: 'dashboard/profile' },
										{ name: 'general', text: 'Account Settings', icon: 'cog', type: 'internal', action: 'dashboard/account', disabled: !props.accountSettingsPermitted }
									]
								},
								{
									name: 'logoutitems',
									title: null,
									items: [
										{ name: 'menu-logout', text: 'Log out', icon: 'sign-out-alt', type: 'custom', action: 'logout', handleClick: handleSignOut },
									]
								},
								{
									name: 'pageitems',
									title: 'Pages',
									items: [
										{ name: 'menu-home', text: 'Home', icon: 'chart-line', type: 'internal', action: 'dashboard/home' },
										{ name: 'menu-embeds', text: 'Embeds', icon: 'puzzle-piece', type: 'internal', action: 'dashboard/embeds' },
										{ name: 'menu-reports', text: 'Reports', icon: 'chart-pie', type: 'internal', action: 'dashboard/reports', permitted: props.reportsPermitted },
										{ name: 'menu-comments', text: `Comments`, icon: 'comment-alt', type: 'internal', action: 'dashboard/commenting', permitted: true },
										// { name: 'menu-ratings', text: `Ratings`, icon: 'star-half-alt', type: 'internal', action: 'dashboard/ratings', permitted: true },
									]
								}
							]}
						/>}
						<Link type={'custom'} name={`logout`} text={props.mocked ? `Unmock` : props.mockupGenerator ? `Back to Mockup Generator` : `Log out`} action={`logout`} handleClick={handleSignOut} icon={`sign-out-alt`} iconRight />
					</Group>
				</Group>
			}
		/>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default LocalHeader;
